import React, { createContext, useContext, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import InspirationContent from '../components/InspirationContent';
import RSVPContent from '../components/RSVPContent';

const EventDialogContext = createContext(null);

export const useEventDialog = () => {
  const ctx = useContext(EventDialogContext);
  if (!ctx) throw new Error('useEventDialog must be used within EventDialogProvider');
  return ctx;
};

export const EventDialogProvider = ({ children }) => {
  const [inspirationOpen, setInspirationOpen] = useState(false);
  const [rsvpOpen, setRsvpOpen] = useState(false);

  const openInspiration = () => {
    setRsvpOpen(false);
    setInspirationOpen(true);
  };
  const openRSVP = () => {
    setInspirationOpen(false);
    setRsvpOpen(true);
  };
  const closeAll = () => {
    setInspirationOpen(false);
    setRsvpOpen(false);
  };

  return (
    <EventDialogContext.Provider value={{ openInspiration, openRSVP, closeAll, inspirationOpen, rsvpOpen }}>
      {children}

      {/* Inspiration Dialog */}
      <Dialog open={inspirationOpen} onOpenChange={setInspirationOpen}>
        <DialogContent className="max-w-6xl w-[95vw] max-h-[90vh] overflow-y-auto bg-neutral-950 border-2 border-orange-600/50 p-0">
          <VisuallyHidden>
            <DialogTitle>Inspiration & Dress code</DialogTitle>
            <DialogDescription>Galerie d'inspiration et code vestimentaire pour Fury Rose</DialogDescription>
          </VisuallyHidden>
          <InspirationContent />
        </DialogContent>
      </Dialog>

      {/* RSVP Dialog */}
      <Dialog open={rsvpOpen} onOpenChange={setRsvpOpen}>
        <DialogContent className="max-w-3xl w-[95vw] max-h-[90vh] overflow-y-auto bg-neutral-950 border-2 border-orange-600/50 p-0">
          <VisuallyHidden>
            <DialogTitle>Confirmation de présence (RSVP)</DialogTitle>
            <DialogDescription>Formulaire pour confirmer votre présence à Fury Rose</DialogDescription>
          </VisuallyHidden>
          <RSVPContent onClose={() => setRsvpOpen(false)} />
        </DialogContent>
      </Dialog>
    </EventDialogContext.Provider>
  );
};
